import React, { Component } from 'react';
import { withStyles } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import {  Cookies } from 'react-cookie';
import ChangeReportOkPay from './ChangeReportOkPay';
import ChangeReportNotPay from './ChangeReportNotPay';




const styles = theme => ({
  paperrtl: {
    marginTop: theme.spacing(0),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  }
  , paper: {
      display: 'flex',
      flexWrap: 'wrap',
      '& > *': {
        margin: theme.spacing(1),
        width: theme.spacing(20),
      },
    },


});

class ChangeReportPay extends Component {
  cookies=new Cookies();
  constructor(props) {
      super(props);
    this.state = {
  value:0,
}}

componentDidMount() {

}
handleChange= (event,newValue) => {
  this.setState({ value:newValue });
}
    render() {
      const { classes } = this.props;
      const { value } = this.state;

        return (
            <div style={{dir:'rtl',direction: 'rtl'}}>
                 <AppBar style={{dir:'rtl'}} position="sticky"color="primary" >

                   <Tabs
                    style={{height:'60px',textAlign:'center',dir:'rtl'}}
                     value={value}
                     onChange={this.handleChange}
                     indicatorColor="secondary"
                     textColor={'#000000'}
                     variant="scrollable"
                     scrollButtons="on"
                               aria-label="scrollable force tabs example"
                   >
                      <Tab label="پرداختی موفق کاربر"  />
                      <Tab label="پرداخت های ناموفق و موفق"  />

                     </Tabs>


                 </AppBar>
                 {(value==0)?<ChangeReportOkPay  props={this.props}/>:null}
                 {(value==1)?<ChangeReportNotPay  props={this.props}/>:null}


               </div>
        );
    }
}

export default  withStyles(styles)(ChangeReportPay);
